import { useHotspots, Hotspot } from 'hooks/queries/designs/useHotspots'
import { showToastMessage } from 'common/ToastMessage/ShowToastMessage'
import { HotspotPopover } from './HotspotPopover'
import { HotspotEdit, HOTSPOT_OPERATIONS } from './Types'
import Styles from './ImageEditor.module.scss'
import { TextInput } from 'blaze-ui/icons'
import { Text } from 'blaze-ui/Text/Text'
import { LoadingEllipses } from 'components/Wizards/Wizard/Form/SectionHeader'

interface SlideProps {
  imageUrl: string
  referenceImageUrl?: string | null
  edits: Map<number, HotspotEdit[]>
  onEditChange: (globalIndex: number, hotspot: Hotspot, edits: HotspotEdit[]) => void
  isDisabled: boolean
}

export const Slide = ({ imageUrl, referenceImageUrl, edits, onEditChange, isDisabled }: SlideProps) => {
  const { data: hotspots, isFetching } = useHotspots(imageUrl, {
    onError: () => {
      showToastMessage('Failed to detect elements in image', 'error')
    },
  })

  return (
    <>
      <img src={imageUrl} alt="Edit text" className={Styles.image} />
      {isFetching && (
        <div className={Styles.ocrOverlay}>
          <Text variant="primary" color="var(--light-90)">
            <span className={Styles.ocrOverlayText}>
              <TextInput /> Detecting elements
              <LoadingEllipses />
            </span>
          </Text>
        </div>
      )}
      {!isDisabled && (
        <div className={Styles.boundingBoxLayer}>
          <div className={Styles.boundingBoxContainer} id="yolo">
            {(hotspots ?? []).map((hotspot, globalIndex) => (
              <HotspotPopover
                key={globalIndex}
                hotspot={hotspot}
                globalIndex={globalIndex}
                edits={edits.get(globalIndex)}
                operations={HOTSPOT_OPERATIONS[hotspot.subject_type]}
                referenceImageUrl={referenceImageUrl}
                onEditChange={onEditChange}
              />
            ))}
          </div>
        </div>
      )}
    </>
  )
}
